/* eslint-disable @typescript-eslint/no-explicit-any */

import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type CambiarConfiguracionRequest = {
  nombre: string | null;
  valor: string | null;
};

type CambiarConfiguracionResponse = {
  state: number;
  value: any;
};

export const cambiarConfiguracion = async (
  config: CambiarConfiguracionRequest
): Promise<any> => {
  try {
    const res = await apiClient.post<CambiarConfiguracionResponse>(
      Endpoints.CambiarConfiguracion,
      config
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
